// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../components/icons/PlusJakartaSans-VariableFont_wght.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../images/login-left-img.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
    font-family: 'PlusJakartaSans'; /* Choose a name for your font */
    src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format('truetype');
    /* Additional font properties can be specified, such as font-weight, font-style, etc. */
  }
.login-container {
    display: flex;
    box-sizing: border-box;
    width: 100vw;
    height: 100vh;
    color:rgb(69, 79, 91);
    font-family: 'PlusJakartaSans', sans-serif;
    overflow: hidden;
}

.login-left {
    width: 60%;
    height: 100%;
    background-color: rgb(31, 31, 105);
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
    background-size:cover; 
    background-repeat: no-repeat;
    background-position: center;
    position:relative;
    display:flex;
    flex-direction: column;
    justify-content: space-between;
}
.login-left-img{
    width: 100%;
    height:100%;
}
.login-top-logo-container{
    width:100%;
    padding:0.5rem 2rem;
    display: flex;
    align-items: center;
    justify-content: center;
}
.login-bottom-logo-container{
    width:100%;
    display: flex;
    padding:1rem 1.5rem;
    align-items: center;
    justify-content: flex-start;
}
.login-bottom-logo{
   max-width:350px;
}
.login-top-logo{
    max-width:100%;
}

.login-right {
    height: 100%;
    width: 40%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding:3rem 0rem;
}

.login-box {
    display: flex;
    flex-direction: column;
    align-items: center;
    /* justify-content: center; */
    width: 70%;
    height: 100%;
    /* background-color: rgb(251, 252, 252); */
    border-radius:0.25rem;
    gap:1rem;
}
.login-box-in{
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    width: 100%;
    height: 100%;
    /* background-color: rgb(251, 252, 252); */
    border-radius:0.25rem;
    gap:2rem;
}
.title-div,
.username-container,
.password-container {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    width: 100%;
}

.title {
    font-size: 32px;
    color: rgb(64, 64, 242);
    margin-bottom:1.5rem;
    font-weight: bold;
}

.subtitle {
    font-size: 16px;
}

.textfield {
    width: 100%;
    height:3rem;
    border:solid 1px rgb(235, 237, 241);
    border-radius: 0.25rem;
    padding:1rem;
}

.username-container label,
.password-container label,
.remember-me-container,
.no-account-div {
    font-size: 14px;
}
.username-container label,
.password-container label{
    /* margin-bottom: 0.25rem; */
}
.title-div,.forgot-container{
    /* margin-bottom:3rem; */
}
.username-container,.password-container{
    /* margin-bottom:2rem; */
}

.forgot-container {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%
}

.remeber-me-container {
    display: flex;
    align-items: center;
    justify-content: center;
}
.forgot-checkbox{
    /* margin-bottom:0; */
}
.forgot-password-btn{
    background: transparent;
    font-weight:500;
    border:none;
    font-family: 'PlusJakartaSans', sans-serif;
}
.sign-in-btn {
    width:90%;
    font-size: 16px;
    background-color: rgb(64, 64, 242);
    color:white;
    height: 3rem;
    border:none;
    /* margin-bottom:3.5rem; */
    border-radius: 0.25rem;
}
.sign-in.title{
    font-weight: bold;
    width:100%;
    text-align: left;
}
@media screen and (max-width: 1279px) {
    .login-box{
        width: 70%;
    }
    .login-bottom-logo{
        max-width:100%;
     }
     .login-top-logo{
         max-width:100%;
     }
     .login-box-in{
        justify-content: center;
     }
}`, "",{"version":3,"sources":["webpack://./src/pages/login/login.css"],"names":[],"mappings":"AAAA;IACI,8BAA8B,EAAE,gCAAgC;IAChE,+DAA2F;IAC3F,uFAAuF;EACzF;AACF;IACI,aAAa;IACb,sBAAsB;IACtB,YAAY;IACZ,aAAa;IACb,qBAAqB;IACrB,0CAA0C;IAC1C,gBAAgB;AACpB;;AAEA;IACI,UAAU;IACV,YAAY;IACZ,kCAAkC;IAClC,yDAAwD;IACxD,qBAAqB;IACrB,4BAA4B;IAC5B,2BAA2B;IAC3B,iBAAiB;IACjB,YAAY;IACZ,sBAAsB;IACtB,8BAA8B;AAClC;AACA;IACI,WAAW;IACX,WAAW;AACf;AACA;IACI,UAAU;IACV,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;AACA;IACI,UAAU;IACV,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,2BAA2B;AAC/B;AACA;GACG,eAAe;AAClB;AACA;IACI,cAAc;AAClB;;AAEA;IACI,YAAY;IACZ,UAAU;IACV,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,6BAA6B;IAC7B,UAAU;IACV,YAAY;IACZ,0CAA0C;IAC1C,qBAAqB;IACrB,QAAQ;AACZ;AACA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,2BAA2B;IAC3B,WAAW;IACX,YAAY;IACZ,0CAA0C;IAC1C,qBAAqB;IACrB,QAAQ;AACZ;AACA;;;IAGI,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,WAAW;AACf;;AAEA;IACI,eAAe;IACf,uBAAuB;IACvB,oBAAoB;IACpB,iBAAiB;AACrB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,WAAW;IACX,mCAAmC;IACnC,sBAAsB;IACtB,YAAY;AAChB;;AAEA;;;;IAII,eAAe;AACnB;AACA;;IAEI,4BAA4B;AAChC;AACA;IACI,wBAAwB;AAC5B;AACA;IACI,wBAAwB;AAC5B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B;AACJ;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;AACA;IACI,qBAAqB;AACzB;AACA;IACI,uBAAuB;IACvB,eAAe;IACf,WAAW;IACX,0CAA0C;AAC9C;AACA;IACI,SAAS;IACT,eAAe;IACf,kCAAkC;IAClC,WAAW;IACX,YAAY;IACZ,WAAW;IACX,0BAA0B;IAC1B,sBAAsB;AAC1B;AACA;IACI,iBAAiB;IACjB,UAAU;IACV,gBAAgB;AACpB;AACA;IACI;QACI,UAAU;IACd;IACA;QACI,cAAc;KACjB;KACA;SACI,cAAc;KAClB;KACA;QACG,uBAAuB;KAC1B;AACL","sourcesContent":["@font-face {\r\n    font-family: 'PlusJakartaSans'; /* Choose a name for your font */\r\n    src: url('../../components/icons/PlusJakartaSans-VariableFont_wght.ttf') format('truetype');\r\n    /* Additional font properties can be specified, such as font-weight, font-style, etc. */\r\n  }\r\n.login-container {\r\n    display: flex;\r\n    box-sizing: border-box;\r\n    width: 100vw;\r\n    height: 100vh;\r\n    color:rgb(69, 79, 91);\r\n    font-family: 'PlusJakartaSans', sans-serif;\r\n    overflow: hidden;\r\n}\r\n\r\n.login-left {\r\n    width: 60%;\r\n    height: 100%;\r\n    background-color: rgb(31, 31, 105);\r\n    background-image: url('../../images/login-left-img.png');\r\n    background-size:cover; \r\n    background-repeat: no-repeat;\r\n    background-position: center;\r\n    position:relative;\r\n    display:flex;\r\n    flex-direction: column;\r\n    justify-content: space-between;\r\n}\r\n.login-left-img{\r\n    width: 100%;\r\n    height:100%;\r\n}\r\n.login-top-logo-container{\r\n    width:100%;\r\n    padding:0.5rem 2rem;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n}\r\n.login-bottom-logo-container{\r\n    width:100%;\r\n    display: flex;\r\n    padding:1rem 1.5rem;\r\n    align-items: center;\r\n    justify-content: flex-start;\r\n}\r\n.login-bottom-logo{\r\n   max-width:350px;\r\n}\r\n.login-top-logo{\r\n    max-width:100%;\r\n}\r\n\r\n.login-right {\r\n    height: 100%;\r\n    width: 40%;\r\n    display: flex;\r\n    flex-direction: column;\r\n    align-items: center;\r\n    justify-content: center;\r\n    padding:3rem 0rem;\r\n}\r\n\r\n.login-box {\r\n    display: flex;\r\n    flex-direction: column;\r\n    align-items: center;\r\n    /* justify-content: center; */\r\n    width: 70%;\r\n    height: 100%;\r\n    /* background-color: rgb(251, 252, 252); */\r\n    border-radius:0.25rem;\r\n    gap:1rem;\r\n}\r\n.login-box-in{\r\n    display: flex;\r\n    flex-direction: column;\r\n    align-items: center;\r\n    justify-content: flex-start;\r\n    width: 100%;\r\n    height: 100%;\r\n    /* background-color: rgb(251, 252, 252); */\r\n    border-radius:0.25rem;\r\n    gap:2rem;\r\n}\r\n.title-div,\r\n.username-container,\r\n.password-container {\r\n    display: flex;\r\n    flex-direction: column;\r\n    align-items: flex-start;\r\n    width: 100%;\r\n}\r\n\r\n.title {\r\n    font-size: 32px;\r\n    color: rgb(64, 64, 242);\r\n    margin-bottom:1.5rem;\r\n    font-weight: bold;\r\n}\r\n\r\n.subtitle {\r\n    font-size: 16px;\r\n}\r\n\r\n.textfield {\r\n    width: 100%;\r\n    height:3rem;\r\n    border:solid 1px rgb(235, 237, 241);\r\n    border-radius: 0.25rem;\r\n    padding:1rem;\r\n}\r\n\r\n.username-container label,\r\n.password-container label,\r\n.remember-me-container,\r\n.no-account-div {\r\n    font-size: 14px;\r\n}\r\n.username-container label,\r\n.password-container label{\r\n    /* margin-bottom: 0.25rem; */\r\n}\r\n.title-div,.forgot-container{\r\n    /* margin-bottom:3rem; */\r\n}\r\n.username-container,.password-container{\r\n    /* margin-bottom:2rem; */\r\n}\r\n\r\n.forgot-container {\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: space-between;\r\n    width: 100%\r\n}\r\n\r\n.remeber-me-container {\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n}\r\n.forgot-checkbox{\r\n    /* margin-bottom:0; */\r\n}\r\n.forgot-password-btn{\r\n    background: transparent;\r\n    font-weight:500;\r\n    border:none;\r\n    font-family: 'PlusJakartaSans', sans-serif;\r\n}\r\n.sign-in-btn {\r\n    width:90%;\r\n    font-size: 16px;\r\n    background-color: rgb(64, 64, 242);\r\n    color:white;\r\n    height: 3rem;\r\n    border:none;\r\n    /* margin-bottom:3.5rem; */\r\n    border-radius: 0.25rem;\r\n}\r\n.sign-in.title{\r\n    font-weight: bold;\r\n    width:100%;\r\n    text-align: left;\r\n}\r\n@media screen and (max-width: 1279px) {\r\n    .login-box{\r\n        width: 70%;\r\n    }\r\n    .login-bottom-logo{\r\n        max-width:100%;\r\n     }\r\n     .login-top-logo{\r\n         max-width:100%;\r\n     }\r\n     .login-box-in{\r\n        justify-content: center;\r\n     }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
